import React from 'react';

export default () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 720.9 234.2"
    >
        <g>
            <g>
                <path fill="#1A1A1A" d="M0,54.1C0,23,22.3,0,52.6,0c30,0,52.4,23,52.4,54.1s-22.4,54.1-52.4,54.1C22.3,108.1,0,85.2,0,54.1
		        	 M88.9,54.1c0-23.1-15.4-40.2-36.4-40.2C31.6,13.9,16,31,16,54.1c0,23.1,15.6,40.2,36.5,40.2C73.5,94.2,88.9,77.2,88.9,54.1"/>
                <path fill="#1A1A1A" d="M110.8,1.2h40.9c21.3,0,34.1,13.1,34.1,31.9c0,18.7-12.8,31.9-34.1,31.9h-25.2v42h-15.7V1.2z M151.3,51.3
		        	c13.6,0,18.9-8.6,18.9-18.3s-5.3-18.3-18.9-18.3h-24.8v36.5H151.3z"/>
                <path fill="#1A1A1A" d="M193.9,89.5v-71c0-11.3,6-17.4,17.4-17.4h50.4v13.9h-46.8c-3.3,0-5.3,2-5.3,5.3v25.1h42.1v13.9h-42.1v28.4
		        	c0,3.3,2,5.3,5.3,5.3h48.5v13.9h-52.1C199.9,106.9,193.9,100.9,193.9,89.5"/>
            </g>
            <polygon fill="#1A1A1A" points="338.4,1.2 338.4,82.6 287.5,1.2 270,1.2 270,106.9 285.7,106.9 285.7,25.7 336.7,106.9 354.1,106.9
		         354.1,1.2 	"/>
            <g>
                <path fill="#1A1A1A" d="M4.8,215.6v-71c0-11.3,6-17.4,17.4-17.4h50.4v13.9H25.8c-3.3,0-5.3,2-5.3,5.3v25.1h42.1v13.9H20.5v28.4
		        	c0,3.3,2,5.3,5.3,5.3h48.5v13.9H22.2C10.9,232.9,4.8,226.9,4.8,215.6"/>
            </g>
            <polygon fill="#1A1A1A" points="143.1,127.2 118.4,166.5 93.8,127.2 77.4,127.2 110.2,179.6 76.7,232.9 93.3,232.9 118.5,192.8
		         143.6,232.9 160,232.9 126.7,179.6 159.4,127.2 	"/>
            <g>
                <path fill="#1A1A1A" d="M156.2,180.1c0-36.2,24.8-54.1,51.6-54.1c24,0,43,14.5,45.9,35.2h-16.5c-1.8-12.4-14.2-21.3-29.6-21.3
                    c-20.5,0-35.3,14-35.3,40.2s14.8,40.2,35.3,40.2c15.7,0,28.2-8.9,29.9-21.3h15.8c-2.3,20.7-21.1,35.2-45.6,35.2
                    C180.7,234.2,156.2,216.3,156.2,180.1"/>
            </g>
            <polygon fill="#1A1A1A" points="329.9,127.2 329.9,171.6 277.5,171.6 277.5,127.2 261.8,127.2 261.8,232.9 277.5,232.9 277.5,185.5
		         329.9,185.5 329.9,232.9 345.6,232.9 345.6,127.2 	"/>
            <path fill="#1A1A1A" d="M397.5,146.9l17.2,45.5h-34.4L397.5,146.9z M390.2,127.2l-41.5,105.7h16.2l10.1-26.9h44.9l10.1,26.9h16.3
		        l-41.5-105.7H390.2z"/>
            <polygon fill="#1A1A1A" points="517.7,127.2 517.7,208.6 466.8,127.2 449.3,127.2 449.3,232.9 465,232.9 465,151.7 516,232.9
		         533.4,232.9 533.4,127.2 	"/>
            <g>
                <path fill="#1A1A1A" d="M542.6,180.1c0-36.1,25.1-54.1,51.8-54.1c24.9,0,43.9,14.8,46.1,35.6h-16.3c-2.1-12.8-14.2-21.8-29.7-21.8
                    c-20.8,0-36.1,14.4-36.1,40.2s15.3,40.6,35.9,40.6c16.2,0,30.8-9.7,30.8-23.4c0-4.1-2.7-7-7.1-7h-23v-12.7h26.9
                    c8.3,0,18.3,6.5,18.3,17.8v37.4H626v-17.8c-4.5,11.3-17.2,19-32.2,19C567.4,234.2,542.6,216.2,542.6,180.1"/>
                <path fill="#1A1A1A" d="M651.5,215.6v-71c0-11.3,6-17.4,17.4-17.4h52.1v13.9h-48.5c-3.3,0-5.3,2-5.3,5.3v25.1h42.1v13.9h-42.1v28.4
		        	c0,3.3,2,5.3,5.3,5.3h48.5v13.9h-52.1C657.5,232.9,651.5,226.9,651.5,215.6"/>
            </g>
            <rect x="390.8" y="92.9" fill="#008285" width="330.1" height="14" />
        </g>
    </svg>
);
